<template>
    <div class="orderList">
        <div class="order">
            <el-form :inline="true" class="demo-form-inline" style="display: flex;">
                <el-form-item>
                    <el-select v-model="dictValue" clearable placeholder="订单类型" @change="stateChange">
                        <el-option  v-for="item in stateData" :key="item.dictValue" :label="item.dictLabel"
                        :value="item.dictValue" ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="List">
            <h1 class="title">订单列表</h1>
            <hr style="margin-left: 43px;margin-right: 29px;margin-top: 12px;">
            <div style="margin: 22px 33px 0 33px;">
                <el-table :data="tableData" style="width: 100%"  :header-cell-style="{'background': '#F7F9FD !important','color': '#333','height': '56px !important'}">
                    <el-table-column type="index" label="序号" width="180" />
                    <el-table-column prop="orderNumber" label="订单号" width="180" />
                    <el-table-column prop="createTime" label="订单开始时间" />
                    <el-table-column prop="deliveryTime" label="订单交付时间" />
                    <el-table-column prop="orderState" label="状态" />
                    <el-table-column  label="操作">
                    <template #default="scope" v-if="dictValue == 1">
                        <el-button link type="primary" size="small" style="color: #002FA7;font-size: 16px;" @click="acceptOrder(scope.row.orderId)">接单</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { factoryAcceptOrder,getDicts } from "@/api/order.js"
import { plantOrderData } from "@/api/mange.js"
import { onMounted,ref } from "vue"
import { ElMessage } from 'element-plus'

const tableData = ref([])
const stateData = ref([])
const dictValue = ref("1")
onMounted(() => {
    orderList()
})
const orderList = () => {
    tableData.value = []
    plantOrderData({orderState:dictValue.value}).then(res => {
        tableData.value = res.data.data
        getDicts("order_state").then(Response => {
            stateData.value = Response.data.data
            tableData.value.map((item,index) => {
                stateData.value.map((val,index) => {
                    if(item.orderState == val.dictValue) {
                        item.orderState = val.dictLabel
                    }
                })
            })
        })
    })
}

const acceptOrder = (val) => {
    factoryAcceptOrder(val).then(res => {
        if(res.data.code == 200) {
            ElMessage.success("接单成功")
            orderList()
        }
    })
}

const stateChange = () => {
    tableData.value = []
    plantOrderData({orderState:dictValue.value}).then(res => {
        tableData.value = res.data.data
        getDicts("order_state").then(Response => {
            stateData.value = Response.data.data
            tableData.value.map((item,index) => {
                stateData.value.map((val,index) => {
                    if(item.orderState == val.dictValue) {
                        item.orderState = val.dictLabel
                    }
                })
            })
        })
    })
}


</script>

<style scoped>  
.orderList {
      /* height: 995px; */
      background: #F8F8F8;
      border-radius: 0px 0px 0px 0px;
      overflow: hidden;
  }

  .order {
      margin: 33px 360px;
      height: 71px;
      background: #FFFFFF;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      padding-left: 32px;
      padding-top: 15px;
      box-sizing: border-box;
      margin-bottom: 0;
  }
  .List {
    margin: 10px 360px;
    height: 727px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    overflow: hidden;
  }
  .title {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 42px;
  margin-top: 20px;
}
::v-deep .el-table__cell {
    text-align: center;
}
</style>
